import { render, staticRenderFns } from "./edit-stockorder.vue?vue&type=template&id=3b11e67e&"
import script from "./edit-stockorder.vue?vue&type=script&lang=ts&"
export * from "./edit-stockorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports